import React from "react";
import _ from "lodash";
import classNames from "classnames";

import useI18n from "Hooks/UseI18n";
import PollResultsModal from "MessagingV2/components/PollsAndForms/PollResultsModal";
import useExpiryCountdown from "MessagingV2/modules/hooks/useExpiryCountdown";
import { useDispatch } from "Hooks/useDispatch";
import { handlePollExpired } from "MessagingV2/modules/MessagingModule";
import { Button } from "@toddle-edu/ds-web";
import classes from "./PollFooter.scss";

const PollCloseTime = ({ expiresAt, messageId, isResponseActive }) => {
  const { t } = useI18n(["common"]);

  const dispatch = useDispatch();

  const onExpire = React.useCallback(() => {
    dispatch(
      handlePollExpired({
        messageId,
      })
    );
  }, [dispatch, messageId]);

  const { isExpired, text } = useExpiryCountdown(expiresAt, onExpire);

  return (
    <div className={classNames(classes.pollFooterEndTime, "text-label-s")}>
      {!isResponseActive || isExpired
        ? t("common:closed")
        : t("common:closes_in_label", {
            label: text,
          })}
    </div>
  );
};

const PollCloseTimeMemo = React.memo(PollCloseTime);

const PollFooter = props => {
  const { interaction, isCreator, messageId } = props;
  const { t } = useI18n(["common"]);

  const expiresAt = _.get(interaction, "expiresAt");

  const [showPollResultsModal, setShowPollResultsModal] = React.useState(false);
  const handleCloseModal = () => {
    setShowPollResultsModal(false);
  };
  const handleOpenModal = () => {
    setShowPollResultsModal(true);
  };

  const options = _.get(interaction, "options", []);

  const totalCount = _.reduce(
    options,
    (sum, pollOption) => sum + _.get(pollOption, "selectedByUsersCount", 0),
    0
  );

  const isResultPublic = _.get(interaction, "isResultPublic", false);

  const canSeeResult = isResultPublic || isCreator;

  const isResponseActive = _.get(interaction, "isResponseActive", false);

  return (
    <>
      <div className={classes.pollFooterContainer}>
        <div className={classes.pollFooterDetails}>
          <div
            className={classNames(classes.pollFooterVoteCount, "text-label-s")}
          >
            {t("common:count_vote", {
              count: totalCount,
            })}
          </div>
          <div className={classes.circularDivider} />
          <PollCloseTimeMemo
            expiresAt={expiresAt}
            messageId={messageId}
            isResponseActive={isResponseActive}
          />
        </div>
        {canSeeResult ? (
          <Button
            dsVersion="2.0"
            className={classes.pollFooterButton}
            variant="progressive"
            size="small"
            type="inline"
            onClick={handleOpenModal}
          >
            {t("common:see_results")}
          </Button>
        ) : null}
      </div>
      {showPollResultsModal ? (
        <PollResultsModal
          onCloseModal={handleCloseModal}
          interaction={interaction}
        />
      ) : null}
    </>
  );
};

export default PollFooter;
